import { DialogActions, DialogTitle, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import globalUseStyles from '../../../styles';
import useStyles from './styles';

const ExcluirDocumento = (props) => {
  const classes = useStyles();
  const globalClasses = globalUseStyles();

  const { open, onClose, documento, onExcluir, afterSubmit } = props;

  const { id, nome, formato } = documento;

  const handleExcluir = async () => {
    await onExcluir(id);
    afterSubmit();
    onClose();
  }

  return (
    <div>
      <Dialog fullWidth open={open} onClose={onClose}>
        <DialogTitle>
          <IconButton className={globalClasses.closeButtonDialog} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography paragraph className={globalClasses.tituloDialog}>Excluir Documento</Typography>
          <Typography paragraph>Tem certeza que deseja excluir esse documento? <br /> Essa ação não pode ser desfeita.</Typography>
          <Typography className={classes.nomeDocumento}>{nome}.{formato}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleExcluir}

          >
            Excluir documento
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ExcluirDocumento;
